/* import __COLOCATED_TEMPLATE__ from './messenger-app.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class MessengerApps extends Component {
  @service store;

  @action
  addMessengerApp(cardJSON, _app, cardCreationParams) {
    this.args.step.cardCreationParams = cardCreationParams;
    this.args.step.previewCanvas = cardJSON.canvas;
    this.args.step.previewMessengerCardUri = cardJSON.uri;
  }

  @action
  removeStep() {
    if (!this.args.step.cardCreationParams?.messenger_app_id) {
      let path = this.args.step.group;
      this.args.editorState.deleteStep(this.args.step, path);
    }
  }

  get messengerApp() {
    return this.store.peekRecord(
      'messenger-app',
      this.args.step.cardCreationParams.messenger_app_id,
    );
  }

  get shouldShowError() {
    return this.args.editorState.shouldShowValidations && !this.args.step.validations.isValid;
  }
}
